import NGODashboardLayout from "layout/dashboardlayout/ngodashboardlayout.js";
import React, { useState } from "react";
import Details from "./Details";
import Overview from "./Overview";
import { useSelector } from "react-redux";

const NGOProjectsLayout = () => {
  const { projects } = useSelector((state) => state.project);
  const [projectData, setprojectData] = useState(projects);

  return (
    <NGODashboardLayout section="Project" infoText="Manage your projects">
      <div className="bg-white rounded-md p-6 max-[450px]:p-3">
        <Details setprojectData={setprojectData} />
        <Overview projectData={projectData} />
      </div>
    </NGODashboardLayout>
  );
};

export default NGOProjectsLayout;
